import { Api } from '@/services/api'

export const getProductsByGoalId = async (token, { params }) => {
	const urlQueryParams = new URLSearchParams(params).toString()
	const encodedParams = encodeURI(urlQueryParams) // encode the url to prevent XSS in search filter
	return Api(token).get(`/V1/Product/GetAllProductsByGoalId?${encodedParams}`)
}

export default undefined
